"use client"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@repo/shad/ui/sidebar"
import { Link, useLocation } from "@tanstack/react-router"

import type { SidebarNavItem } from "../types"

export function NavMain({
  items,
  label,
  resolveUrl,
}: {
  items: SidebarNavItem[]
  label?: string
  resolveUrl?: (url: string) => string
}) {
  const { pathname } = useLocation()
  const { setOpenMobile, isMobile } = useSidebar()

  return (
    <SidebarGroup>
      {label && <SidebarGroupLabel>{label}</SidebarGroupLabel>}
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            const href = resolveUrl ? resolveUrl(item.url) : item.url
            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  tooltip={item.title}
                  isActive={pathname === href || pathname.startsWith(`${href}/`)}
                  asChild
                >
                  <Link to={item.url} onClick={() => isMobile && setOpenMobile(false)}>
                    {item.icon && <item.icon />}
                    <span>{item.title}</span>
                    {item?.badge && (
                      <span className="text-xs text-card-foreground/40 ml-auto">{item.badge}</span>
                    )}
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
